import * as React from 'react';
import {Translation} from 'react-i18next';
import {BI_ERRORS} from '../../services/biErrorLogger/biErrors';
import {errorLogger} from '../../services/errorLogger/errorLogger';
import {ErrorState} from '../ErrorState/ErrorState';
import styles from './ErrorBoundary.scss';
import {IOuter, IState} from './ErrorBoundary.types';

export class ErrorBoundary extends React.Component<IOuter, IState> {
  displayName: 'ErrorBoundary';

  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(reason, errorInfo) {
    errorLogger.logError({bi: BI_ERRORS.getWindow.unhandled.boundary}, {reason});
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.errorBoundary} data-hook="generic-error-boundary">
          <ErrorState>
            <Translation>
              {(t) => (
                <h3 className={styles.title} data-hook="error-title">
                  {t('mgw.errorStateTitle')}
                </h3>
              )}
            </Translation>
          </ErrorState>
        </div>
      );
    }
    return this.props.children;
  }
}
